import { z } from 'zod';

/**
 * Schéma pour la création/édition d'une matière (Offre établissement)
 */
export const subjectSchema = z.object({
  name: z.string().min(2, 'Le nom doit contenir au moins 2 caractères'),
  code: z
    .string()
    .min(2, 'Le code doit contenir au moins 2 caractères')
    .max(10, 'Le code ne peut pas dépasser 10 caractères')
    .regex(
      /^[A-Z0-9-]+$/,
      'Le code doit contenir uniquement des majuscules, chiffres et tirets'
    ),
  description: z.string().optional(),
  typeId: z.number().optional(),
  establishmentId: z.string().min(1, "L'établissement est requis"),
  levelIds: z.array(z.number()).default([]),
});

export type SubjectFormData = z.infer<typeof subjectSchema>;
